import { Injectable } from '@angular/core';
import { LoggedInUser } from '../models/loggedinuser';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor() { }

  async hasPermission(permission:string):Promise<boolean> {
    let user = await this.getLoggedInUser();
    return user.permissions.filter(p => p === permission).length > 0;
  }

  async getLoggedInUser():Promise<LoggedInUser> {
    return {
      email: "jason.krumbholz@gmail.com",
      permissions: ["EVENTADMIN", "PLAYERADMIN"]
    }
  }
}
